import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import initials from 'initials';
import Theme from '../Theme';
import { Image } from './elements'; // Define some colors

var defaultColors = [Theme.palette.avatar.emerald, Theme.palette.avatar.river, Theme.palette.avatar.wisteria, Theme.palette.avatar.carrot, Theme.palette.avatar.alizarin, Theme.palette.avatar.turquoise];
/**
 * Sum Chars
 *
 * Do the sums of the caracteres of a string
 *
 * @return {jsx}
 */

function sumChars(str) {
  var sum = 0;

  for (var i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }

  return sum;
}
/**
 * An Avatar depicts an user with an image if its path is provided.
 * It fallbacks to the initials of the person.
 *
 * @return {jsx}
 */


var Avatar = function Avatar(_ref) {
  var className = _ref.className,
      name = _ref.name,
      size = _ref.size,
      src = _ref.src;
  var abbr = initials(name);
  var normalizeSize = size * 10;
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": name,
    className: className
  }, src && /*#__PURE__*/React.createElement(Image, {
    src: src,
    width: normalizeSize,
    height: normalizeSize,
    alt: name
  }), !src && /*#__PURE__*/React.createElement("span", null, abbr));
};
/**
 * PropTypes validation
 */


Avatar.propTypes = {
  /**
   * className needed by styled component
   */
  className: PropTypes.string,

  /**
   * name that will form the displayed initials
   */
  name: PropTypes.string.isRequired,

  /**
   * size of the avatar
   */
  size: PropTypes.number,

  /**
   * source image of a user
   */
  src: PropTypes.string
};
/**
 * Default propTypes
 */

Avatar.defaultProps = {
  className: '',
  size: Theme.dimensions.bigInt,
  src: null
};
export default styled(Avatar).withConfig({
  displayName: "Avatar",
  componentId: "sc-1v45c5l-0"
})(["display:flex;justify-content:center;align-items:center;width:", "rem;height:", "rem;border-radius:50%;background:", ";color:white;"], function (_ref2) {
  var size = _ref2.size;
  return size || Theme.dimensions.bigInt;
}, function (_ref3) {
  var size = _ref3.size;
  return size || Theme.dimensions.bigInt;
}, function (_ref4) {
  var name = _ref4.name;
  return defaultColors[sumChars(name) % defaultColors.length];
});